/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { SocialCausesService } from '@shared/services/social-causes.service';

@Component({
  selector: 'app-social-causes',
  templateUrl: './social-causes.page.html',
  styleUrls: ['./social-causes.page.scss'],
})
export class SocialCausesPage implements OnInit {
  protected selectedCauses: string[] = [];
  protected saveChangesButton: boolean = false;
  protected nextButtonHidden: boolean = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected userData: any;
  protected firstSetup: boolean;
  protected causes: { id: string; text: string }[] = [];
  protected currentLanguage: string = 'en';

  constructor(
    public modalCtrl: ModalController, 
    public navParams: NavParams,
    private translate: TranslateService,
    public socialCausesService: SocialCausesService
  ) {
    this.userData = this.navParams.get('theSoul'); //getting 'user' data
    this.firstSetup = this.navParams.get('firstSetup');
    this.currentLanguage = this.translate.currentLang || 'en';
    
    // Initialize selected causes from user data (these should be IDs)
    if (this.userData?.socialCauses) {
      this.selectedCauses = [...this.userData.socialCauses];
    }
    
    // Load causes based on current language
    this.loadCauses();
  }

  ngOnInit(): void {
  }

  loadCauses() {
    this.causes = this.socialCausesService.getCausesForLanguage(this.currentLanguage);
  }

  // Toggle cause selection
  toggleCause(causeId: string) {
    if (this.isCauseSelected(causeId)) {
      // Remove cause if already selected
      this.selectedCauses = this.selectedCauses.filter(c => c !== causeId);
    } else {
      // Add cause only if under maxCauses selections
      if (this.selectedCauses.length < this.socialCausesService.getSocialCausesData().maxCauses) {
        this.selectedCauses.push(causeId);
      }
    }
    this.showSaveButton();
  }

  // Check if cause is selected
  isCauseSelected(causeId: string): boolean {
    return this.selectedCauses.includes(causeId);
  }

  //closes modal without saving
  exitButton() {
    this.modalCtrl.dismiss('exitModal');
  }

  //switches 'exitButton' to 'saveButton'
  showSaveButton() {
    this.saveChangesButton = true;
  }

  //saves changes made by user
  saveButton() {
    this.savesOption();
    this.modalCtrl.dismiss({ data: this.userData, action: 'exitModal' });
  }

  //"goes back" 1 modal and saves info
  backButton() {
    this.savesOption();
    this.modalCtrl.dismiss({ data: this.userData, action: 'backModal' });
  }

  //saves info and closes modal
  nextButton() {
    this.savesOption();
    this.modalCtrl.dismiss({ data: this.userData, action: 'nextModal' });
  }

  savesOption() {
    this.userData.socialCauses = [...this.selectedCauses];
    console.log('Social causes saved:', this.userData.socialCauses);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SocialCausesPage');
  }
}
